export default {
  root: ({ props, state }) => ({
    class: [
      // Display and Position
      'inline-flex',
      'align-items-center',
      'relative',

      // Shape
      'rounded',

      'w-full',

      // Color and Background
      'bg-white dark:bg-surface-900',
      'border',
      { 'border-zinc-300 dark:border-surface-600': !props.invalid },

      // Invalid State
      { 'border-red-500 dark:border-red-400': props.invalid },

      // Transitions
      'transition-all',
      'duration-200',

      // States
      {
        'ring ring-primary-400/50 dark:ring-primary-300/50': state.focused
      },

      // Misc
      'cursor-pointer',
      'select-none',
      {
        'opacity-60': props.disabled,
        'pointer-events-none': props.disabled,
        'cursor-default': props.disabled
      }
    ]
  }),
  labelContainer: {
    class: 'overflow-hidden flex flex-auto cursor-pointer justify-stretch'
  },
  label: ({ props }) => ({
    class: [
      'leading-base',
      'block p-1',

      'w-full',

      // Spacing
      {
        'p-3': props.display !== 'chip',
        'px-3 py-1': props.display === 'chip' && !props?.modelValue?.length,
        'p-1': props.display === 'chip' && props?.modelValue?.length > 0
      },

      // Color
      {
        'text-surface-800 dark:text-white/80': props.modelValue?.length,
        'text-surface-400 dark:text-surface-500': !props.modelValue?.length
      },
      'placeholder:text-surface-400 dark:placeholder:text-surface-500',

      // Transitions
      'transition duration-200',

      // Misc
      'overflow-hidden whitespace-nowrap cursor-pointer overflow-ellipsis'
    ]
  }),
  token: {
    class: [
      // Flex
      'inline-flex items-center',

      // Spacings
      'py-1 px-2 mr-2 leading-none',

      // Shape
      'rounded',

      // Colors
      'bg-gray-200 dark:bg-surface-700',
      'text-gray-600 dark:text-white/70',

      // Misc
      'cursor-default'
    ]
  },
  removeTokenIcon: {
    class: [
      // Shape
      'rounded leading-base',

      // Spacing
      'ml-2',

      // Size
      'size-2',

      // Transition
      'transition duration-200 ease-in-out',

      // Misc
      'cursor-pointer'
    ]
  },
  trigger: {
    class: [
      // Flexbox
      'flex items-center justify-center',
      'shrink-0',

      // Color and Background
      'bg-transparent',
      'text-surface-500',

      // Size
      'w-12',

      // Shape
      'rounded-tr-md',
      'rounded-br-md',

      // Position
      'ml-auto',
      'mr-2'
    ]
  },
  panel: {
    class: [
      // Position
      'bg-white',

      // Shape
      'border border-zinc-300',
      'rounded',
      'shadow-sm',

      // Color
      'text-neutral-500 dark:text-white/80',
      'dark:border-surface-700',
      '!overflow-y-scroll !mt-1'
    ]
  },
  header: {
    class: [
      'flex items-center justify-between',
      // Spacing
      'p-2',
      'm-0',

      //Shape
      'border-b',
      'rounded-tl-md',
      'rounded-tr-md',

      // Color
      'text-surface-700 dark:text-white/80',
      'bg-surface-100 dark:bg-surface-800',
      'border-surface-300 dark:border-surface-700'
    ]
  },
  headerCheckboxContainer: {
    class: [
      'relative',

      // Alignment
      'inline-flex',

      // Size
      'size-5',

      // Misc
      'cursor-pointer',
      'select-none'
    ]
  },
  headerCheckbox: {
    root: {
      class: [
        'relative',

        // Alignment
        'inline-flex',

        // Size
        'size-5',

        // Spacing
        'mr-2',

        // Misc
        'cursor-pointer',
        'select-none'
      ]
    },
    box: ({ props, context }) => ({
      class: [
        // Alignment
        'flex',
        'items-center',
        'justify-center',

        // Size
        'size-5',

        // Shape
        'rounded',
        'border-0 focus:outline-0 focus:ring-0 focus:ring-offset-0',

        'ring-0 ring-offset-0',

        // Colors
        {
          'bg-zinc-300 border-zinc-300 hover:bg-zinc-400 hover:border-zinc-400':
            !context.checked,
          'border-primary bg-primary': context.checked
        },

        // States
        {
          'cursor-default opacity-60': props.disabled
        },

        // Transitions
        'transition-colors',
        'duration-200'
      ]
    }),
    input: {
      class: [
        // Size
        'size-full',

        // Position
        'absolute',
        'top-0 left-0',
        'z-10',

        // Spacing
        'p-0',
        'm-0',

        // Shape
        'opacity-0',
        'rounded',
        'outline-0',
        'border-0',

        // Misc
        'appearance-none',
        'cursor-pointer'
      ]
    },
    icon: {
      class: [
        // Font
        'text-base leading-none',

        // Size
        'size-2',

        // Colors
        'text-white dark:text-surface-900',

        // Transitions
        'transition-all',
        'duration-200'
      ]
    }
  },
  itemCheckbox: {
    root: {
      class: [
        'relative',

        // Alignment
        'inline-flex',

        // Size
        'size-5',

        // Spacing
        'mr-2',

        // Misc
        'cursor-pointer',
        'select-none'
      ]
    },
    box: ({ props, context }) => ({
      class: [
        // Alignment
        'flex',
        'items-center',
        'justify-center',

        // Size
        'size-5',

        // Shape
        'rounded',
        'border-0 focus:outline-0 focus:ring-0 focus:ring-offset-0',

        //Colors
        {
          'bg-zinc-300 border-zinc-300 hover:bg-zinc-400 hover:border-zinc-400':
            !context.checked,
          'border-primary bg-primary font-bold': context.checked
        },

        // States
        {
          'cursor-default opacity-60': props.disabled
        },

        // Transitions
        'transition-colors',
        'duration-200'
      ]
    }),
    input: {
      class: [
        // Size
        'w-full ',
        'h-full',

        // Position
        'absolute',
        'top-0 left-0',
        'z-10',

        // Spacing
        'p-0',
        'm-0',

        // Shape
        'opacity-0',
        'rounded',
        'outline-0',
        'border-0',

        // Misc
        'appearance-none',
        'cursor-pointer'
      ]
    },
    icon: {
      class: [
        // Font
        'text-base leading-none',

        // Size
        'size-2',

        // Colors
        'text-white dark:text-surface-900',

        // Transitions
        'transition-all',
        'duration-200'
      ]
    }
  },
  closeButton: {
    class: [
      'relative',

      // Flexbox and Alignment
      'flex items-center justify-center',

      // Size and Spacing
      'mr-2',
      'last:mr-0',
      'w-8 h-8',

      // Shape
      'border-0',
      'rounded-full',

      // Colors
      'text-surface-500',
      'bg-transparent',

      // Transitions
      'transition duration-200 ease-in-out',

      // States
      'hover:text-surface-700 dark:hover:text-white/80',
      'hover:bg-surface-100 dark:hover:bg-surface-800/80',
      'focus:outline-0 focus:outline-offset-0 focus:ring focus:ring-inset',
      'focus:ring-primary-400/50 dark:focus:ring-primary-300/50',

      // Misc
      'overflow-hidden'
    ]
  },
  closeButtonIcon: {
    class: 'w-4 h-4 inline-block'
  },
  wrapper: {
    class: [
      // Sizing
      'max-h-[200px]',

      // Misc
      'overflow-auto'
    ]
  },
  list: {
    class: 'py-3 list-none m-0'
  },
  item: ({ context }) => ({
    class: [
      'relative flex align-items-center',

      // Font
      'font-normal text-base leading-[normal]',

      // Spacing
      'm-0 px-2 py-1',

      // Shape
      'border-0 rounded-none',

      'hover:bg-gray-200 dark:hover:bg-surface-600/80',
      { 'hover:bg-primary/[0.4]': context.selected },
      'focus-visible:outline-0 focus-visible:outline-offset-0 focus-visible:ring focus-visible:ring-inset focus-visible:ring-primary-400/50 dark:focus-visible:ring-primary-300/50',

      // Transition
      'transition-shadow duration-200',

      // Misc
      'cursor-pointer overflow-hidden whitespace-nowrap'
    ]
  }),
  itemgroup: {
    class: [
      //Font
      'font-bold',

      // Spacing
      'm-0',
      'p-3 px-5',

      // Color
      'text-surface-800 dark:text-white/80',
      'bg-surface-0 dark:bg-surface-600/80',

      // Misc
      'cursor-auto'
    ]
  },
  filtercontainer: {
    class: 'relative w-full mx-2'
  },
  filterinput: {
    class: [
      // Font
      'leading-[normal]',

      // Sizing
      'pr-7 py-3 px-3',
      '-mr-7',
      'w-full',

      //Color
      'text-surface-700 dark:text-white/80',
      'bg-surface-0 dark:bg-surface-900',
      'border-surface-200 dark:border-surface-700',
      'placeholder:text-surface-400 dark:placeholder:text-surface-500',

      // Shape
      'border',
      'rounded-lg',
      'appearance-none',

      // Transitions
      'transition',
      'duration-200',

      // States
      'hover:border-primary',
      'focus:ring focus:outline-0 focus:outline-offset-0',
      'focus:ring-primary-400/50 dark:focus:ring-primary-300/50',

      // Misc
      'appearance-none'
    ]
  },
  filtericon: {
    class: ['absolute', 'top-1/2 right-3', '-mt-2']
  },
  clearicon: {
    class: [
      // Color
      'text-surface-500',

      // Position
      'absolute',
      'top-1/2',
      'right-12',

      // Spacing
      '-mt-2'
    ]
  },
  emptymessage: {
    class: [
      // Font
      'leading-none',

      // Spacing
      'py-3 px-5',

      // Color
      'text-surface-800 dark:text-white/80',
      'bg-transparent'
    ]
  },
  transition: {
    enterFromClass: 'opacity-0 scale-y-[0.8]',
    enterActiveClass:
      'transition-[transform,opacity] duration-[120ms] ease-[cubic-bezier(0,0,0.2,1)]',
    leaveActiveClass: 'transition-opacity duration-100 ease-linear',
    leaveToClass: 'opacity-0'
  }
}
